<mat-card class="mat-elevation-z0 tasks-header-container">
    <mat-card-title class="tasks-header-label">Tasks</mat-card-title>
    <app-stop-all-processes-button [stopTasks]="true"></app-stop-all-processes-button>
</mat-card>
<div class="tasks-list-container">
    <app-tasks-list [tasks]="tasks"></app-tasks-list>
</div>
<mat-paginator [length]="totalJobsCount" [pageSize]="DEFAULT_PAGE_SIZE" [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS"
    (page)="pageChanged($event)" aria-label="Select page" [showFirstLastButtons]="true">
</mat-paginator>

<app-spinner [showOverlay]="true" *ngIf="showSpinner"></app-spinner>
